<template>
  <div class="left_col scroll-view">

    <!-- sidebar menu -->
    <div class="hidden-sm-and-down left_col_wrapper white">
    <dl class="ml-3 mt-4 setting-menu">
      <dd :class="{'current-page': $route.path === '/display'}" v-show="requiredRoles([])" class="mb-4"><router-link to="/settings/display">{{$t("settings.display-setting")}}</router-link></dd>

      <dt>{{$t("settings.available-sensor")}}</dt>
      <dd :class="{'current-page': $route.path === '/plugins'}" v-show="requiredRoles([])" class="mb-3">
        <router-link v-if="userRole !== ROLE_Viewer" to="/settings/plugins#flowsensor">{{$t("sensor.flow")}}</router-link>
        <span v-else class="grey--text">{{$t("sensor.flow")}}</span></dd>
      <dd :class="{'current-page': $route.path === '/plugins'}" v-show="requiredRoles([])" class="mb-3">
        <router-link v-if="userRole !== ROLE_Viewer" to="/settings/plugins#tdssensor">{{$t("sensor.tds")}}</router-link>
        <span v-else class="grey--text">{{$t("sensor.tds")}}</span></dd>
      <dd :class="{'current-page': $route.path === '/plugins'}" v-show="requiredRoles([])" class="mb-3">
        <router-link v-if="userRole !== ROLE_Viewer" to="/settings/plugins#pressuresensor">{{$t("sensor.pressure")}}</router-link>
        <span v-else class="grey--text">{{$t("sensor.pressure")}}</span></dd>
      <dd :class="{'current-page': $route.path === '/plugins'}" v-show="requiredRoles([])" class="mb-3">
        <router-link v-if="userRole !== ROLE_Viewer" to="/settings/plugins#leakagesensor">{{$t("sensor.leakage")}}</router-link>
        <span v-else class="grey--text">{{$t("sensor.leakage")}}</span></dd>
      <dd :class="{'current-page': $route.path === '/plugins'}" v-show="requiredRoles([])" class="mb-3">
        <router-link v-if="userRole !== ROLE_Viewer" to="/settings/plugins#temperaturesensor">{{$t("sensor.temperature")}}</router-link>
        <span v-else class="grey--text">{{$t("sensor.temperature")}}</span></dd>

      <dt>{{$t("settings.life-and-notification")}}</dt>
      <dd :class="{'current-page': $route.path === ''}" class="mb-4 grey--text">{{$t("settings.notification-presets")}}</dd>
      <dd :class="{'current_page': $route.path === '/settings/notifications_mail'}" class="mb-3"><router-link to="/settings/notifications_mail">{{$t("settings.notification-mail")}}</router-link></dd>
      <dt>{{$t("settings.organization-user")}}</dt>
      <dd :class="{'current-page': $route.path === '/pc_list'}" v-if="userRole===ROLE_Root" class="mb-3"><router-link to="/settings/pc_list">{{$t("settings.pc-management")}}</router-link></dd>
      <dd :class="{'current-page': $route.path === '/organizations_detail'}" v-if="userRole!==ROLE_Root" class="mb-3">
        <router-link v-if="userRole!==ROLE_Staff && userRole !== ROLE_Viewer" to="/settings/organizations_detail">{{$t("settings.management-organization")}}</router-link>
        <span v-else class="grey--text">{{$t("settings.management-organization")}}</span></dd>
      <dd :class="{'current-page': $route.path === '/user_list'}" v-if="userRole!==ROLE_Root"  class="mb-3">
        <router-link v-if="userRole!==ROLE_Staff && userRole !== ROLE_Viewer" to="/settings/user_list">{{$t("settings.user-management")}}</router-link>
        <span v-else class="grey--text">{{$t("settings.user-management")}}</span></dd>
      <dd :class="{'current-page': $route.path === '/user_invite'}" v-if="userRole!==ROLE_Root"  class="mb-4">
        <router-link v-if="userRole!==ROLE_Staff && userRole !== ROLE_Viewer" to="/settings/user_invite">{{$t("settings.user-invitation")}}</router-link>
        <span v-else class="grey--text">{{$t("settings.user-invitation")}}</span>
        </dd>
    </dl>
  </div>
    <!-- /sidebar menu -->
  </div>
</template>

<script>
import config from '@/config.js'

export default {
  name: 'Sidebar',
  data () {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      ROLE_Root: config.role.Root,                   // Roleの定数
      ROLE_Administrator: config.role.Administrator, // Roleの定数
      ROLE_Manager: config.role.Manager,             // Roleの定数
      ROLE_Staff: config.role.Staff,                 // Roleの定数
      ROLE_Viewer: config.role.Viewer                // Roleの定数
    }
  },
  methods: {
    requiredRoles (roles) {
      return this.$store.getters.userHasThoseRoles(roles)
    },
    manualUrl () {
      return process.env.manualUrl
    }
  }
}
</script>

<style>

.left_col_wrapper{
  /*
    position: fixedを利用した場合、以下の問題点がある。
    1. デフォルトのブラウザサイズのChrome、もしくはズームサイズを極端に縮小したChromeにて
       User Inviteの組織選択のプルダウンを開いた後、マウスホイールを上下させてもスクロールしないことがある
    2. 画面サイズの高さを大幅に縮小した場合に左メニューの下部が選択できなくなってしまう。

    これを解決するため、float:left;max-width:280px;を利用し、
    左メニューは右コンテンツと同時にスクロール可能にする。
    また、height:には100vh(ブラウザサイズの高さ100%)が入っているので、上部バーの高さと合わせて、
    ページコンテンツ領域の高さが常にブラウザサイズの高さを超えるため、
    User Invite表示時にも右にスクロールバーが表示されるため、組織選択のプルダウンのスクロールも可能になる
  */
  float: left;
  min-width: 280px;
  max-width: 280px;
  min-height: 100vh;
  max-height: 300vh;
  border-right: 1px #D0D5E2 solid !important;
}

.setting-menu a{
  color: #000!important;
}
.setting-menu dt{
  color: #ACACAC;
  font-size: 12px;
  margin: 0 0 16px 0;
  border-top: 1px #CCC solid;
  padding-top:5px;
}
.setting-menu dd{
  font-size: 16px;
  margin: 0 0 8px 0;
}

.sub-nav .menu{
  position: absolute;
  top:20px;
  right: 20px;
}

@media screen and (min-width: 959px) {
  .sub-nav{
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// SettingsSidebar.vue?69839c04